import { Typography } from '@mui/material';
import React, { ReactNode, useState } from 'react';

type IssCheckboxProps = {
  description: string;
  onHandleChanged: (checked: boolean) => void;
  additionalText?: ReactNode;
}

export const IssCheckbox: React.FC<IssCheckboxProps> = ({ description, onHandleChanged, additionalText }) => {
  const [checked, setChecked] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    setChecked(newChecked);
    onHandleChanged(newChecked);
  };

  return (
    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        style={{ marginRight: '8px' }}
      />
       <Typography variant="body2">
        {description}
        {additionalText && <> {additionalText}</>}
      </Typography>
      
    </label>
  );
};